export default "/packs/images/people-sharp~3c6a0a9d0ccec201e752e44cf7672af8.svg";